<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px">
            <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary"
                       class="mt-4"
                       dark
                       v-bind="attrs"
                       v-on="on">
                    Create Ad-hoc Material
                </v-btn>
            </template>
            <v-card>
                <v-card-title>
                    <span class="headline">Create Ad-hoc Material</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form ref="form" v-model="valid">
                            <v-row>
                                <v-col>
                                    <v-textarea v-model="material.name" label="Material name *" outlined :counter="512" :rules="rules.name" required></v-textarea>
                                </v-col>
                                <v-col cols="12">
                                    <v-select v-model="material.uomId"
                                              :items="uom"
                                              label="Unit of Measure *"
                                              item-text="description"
                                              :item-value="material.uomId"
                                              :loading="uomLoading"
                                              :rules="rules.uom"
                                              required></v-select>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field v-model.number="roItem.quantity" label="Quantity *" :rules="rules.quantity" type="number" required></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <CurrencyInput v-model.number="material.currentPrice" label="Estimate Price" prefix="$"></CurrencyInput>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                    <small>* indicates required field</small>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog = false; reset();">Close</v-btn>
                    <v-btn color="blue darken-1" text @click="saveMaterial();" :disabled="!valid" :loading="submitting">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import CurrencyInput from '@/components/CurrencyInput.vue';
    import { mapActions, mapGetters } from 'vuex';
    import appsettings from '../../appsettings.js';
    import axios from "axios";
    export default {
        data: () => ({
            dialog: false,
            props: {
                search: String,
                enableAdhoc: Boolean
            },
            defaultUomId: "EA",
            material: {
                uomId: "EA",
                materialGroupId: appsettings.config.adHocGroup,
                name: "",
                description: "",
                isAdHoc: true,
                isActive: true,
                currentPrice: 0.00
            },
            roItem: {
                quantity: 1
            },
            rules: {
                name: [
                    v => !!v || 'Name is required',
                    v => (v && v.length >= 10) || 'Name must be at least 10 characters',
                    v => (/\S/.test(v)) || 'Name cannot contain only spaces',
                    v => (!/[^0-9a-zA-Z:,.'"-\s\\/]+/.test(v)) || 'Can not contain special characters',
                    v => (v && v.length <= 512) || 'Name must be less than 512 characters'
                ],
                quantity: [
                    v => !!v || 'Quantity is required',
                    v => (v && v > 0) || 'Quantity must be greater than 0 (zero)'
                ],
                uom: [v => !!v || 'Unit of Measure is required']
            },
            valid: false,
            uom: [],
            materialGroupsLoading: false,
            uomLoading: false,
            submitting: false,
            notification: 0,
            requisitionOrderId: 0
        }),
        components: {
            CurrencyInput
        },
        async mounted() {
            await this.getUoMFromApi();
            this.requisitionOrderId = this.$route.params.requisitionOrderId;
        },
        methods: {
            ...mapActions(["sendMessage"]),
            async getUoMFromApi() {

              this.uomLoading = true;
              let response = await axios.get(`/api/Lookup/uom`)
              let data = response.data;
              
              data.sort((a, b) => a.id.localeCompare(b.id));
              this.uom = data;
              let found = this.uom.some(el => el.id === this.defaultUomId);

              if (found)
                this.material.uomId = this.defaultUomId;
              this.uomLoading = false;
              
              return data;

            },
            async saveMaterial() {
                if (this.valid) {

                  try {
                    let now = new Date();
                    let locationId = this.$route.params.locationId;
                    let locationDepartmentId = this.$route.params.locationDepartmentId;
  
                    let materialRequest = {
                        ...this.material,
                      };
                      materialRequest.description = materialRequest.name.trim();
  
                    let materialResponse = await axios.post(`/api/Material`,materialRequest);
                    let material = materialResponse.data;
                    let orderItemRequest = {
                        ...material,
                        ...this.roItem,
                        locationDepartmentId: locationDepartmentId,
                        locationId: locationId
                    };
                    
                    axios.post(`/api/RequisitionOrder/${this.requisitionOrderId}/material`,orderItemRequest);
                    
                    this.sendMessage({
                      color: "success",
                      text: "Ad-Hoc material successfuly created and added to the active Requisition Order!",
                      timeout: 6000
                    });
                  }
                  catch(error) {
                    this.sendMessage({
                      color: "error",
                      text: "Failed to include ad-Hoc material to the active Requisition Order!",
                      timeout: 6000
                    });
                  }

                  this.clear();
                  this.submitting = false;
                    this.dialog = false;
                    this.$emit('clearSearch');

                }
            },
            clear() {
                this.roItem.quantity = 1;
                this.material.name = "";
                this.material.description = "";
                this.material.currentPrice = 0.00;
                this.search = "";
                this.enableAdhoc = false;
                let found = this.uom.some(el => el.id === this.defaultUomId);
                if (found) this.material.uomId = this.defaultUomId;
            },
            reset() {
                this.clear();
            }
        },
        computed: {
            locationDepartmentId() { return this.$root.$children[0].selectedDepartment; },
            ...mapGetters(['getVrsUser'])
        }
    }
</script>